import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import {
  PaymentAction,
  AccountReviewAction,
  ActivityAction,
  InitAction
} from "../actions";
import * as paymentApi from "../api/payment";
import { toastr } from "react-redux-toastr";
import { push, goBack } from "connected-react-router";
import queryString from "query-string";
import { createBrowserHistory } from "history";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";

export function* watcherPayment() {
  yield takeLatest(types.API_REMOVE_PAYMENT_REQUEST, remove);
  yield takeLatest(types.STORE_PAYMENT_REQUEST, store);
  yield takeLatest(types.GET_PAYMENT_REQUEST, get);
  yield takeLatest(types.UPDATE_PAYMENT_REQUEST, update);
}

async function removeReq(id) {
  return paymentApi.remove(id);
}

function* remove(action) {
  const history = createBrowserHistory();
  try {
    const response = yield call(
      removeReq,
      action.id,
      action.getActivityListData
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(PaymentAction.removeSuccess(response.data, action.id));
    yield put(InitAction.getSuccess({ premium: response.data.premium }));
    if (
      action.getActivityListData !== null &&
      action.getActivityListData.activityDetail
    ) {
      yield put(ActivityAction.getAll(action.getActivityListData.data));
    } else {
      let urlFilters = queryString.parse(document.location.search);
      yield put(AccountReviewAction.get(urlFilters.tab || 1));
    }
    if (action.goBack) {
      if (history.location.state && history.location.state.from) {
        yield put(push(history.location.state.from));
      } else {
        yield put(goBack());
      }
    }
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(PaymentAction.removeFailure(error, action.id));
  }
}

async function storeReq(data) {
  return paymentApi.store(data);
}

function* store(action) {
  const history = createBrowserHistory();
  try {
    const response = yield call(storeReq, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    for (let i = 0; i < action.files.length; i++) {
      const imageResponse = yield call(
        storeImageReq,
        action.files[i],
        response.data.data.id
      );
      yield put(InitAction.getSuccess({ premium: imageResponse.data.premium }));
    }
    yield put(PaymentAction.storeSuccess());
    if (
      history.location.state &&
      history.location.state.from === "/pettycash"
    ) {
      yield put(
        push({ pathname: history.location.state.from, state: { from: "/" } })
      );
    } else {
      yield put(
        push({
          pathname: `/summary-payment/${response.data.data.id}`,
          state: { from: "/" }
        })
      );
    }
    // if(action.data.payment_subject === PaymentSubjects.KARKARD_PAYMAN_KARAN){
    //   yield put(push("/account-review?date_type=3&end_date=&start_date=&tab=3"));
    // }else {
    //   yield put(push("/account-review"));
    // }
  } catch (error) {
    yield put(PaymentAction.storeFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}
async function updateReq(id, data) {
  return paymentApi.update(id, data);
}
function* update(action) {
  try {
    const response = yield call(updateReq, action.id, action.data);
    yield put(InitAction.getSuccess({ premium: response.data.premium }));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    for (let i = 0; i < action.files.length; i++) {
      if (!action.files[i].id) {
        const imageResponse = yield call(
          storeImageReq,
          action.files[i],
          response.data.data.id
        );
        yield put(
          InitAction.getSuccess({ premium: imageResponse.data.premium })
        );
      }
    }
    yield put(PaymentAction.updateSuccess());
    yield put(goBack());
    // if(action.data.payment_subject === PaymentSubjects.KARKARD_PAYMAN_KARAN){
    //   yield put(push("/account-review?date_type=3&end_date=&start_date=&tab=3"));
    // }else {
    //   yield put(push("/account-review"));
    // }
  } catch (error) {
    yield put(PaymentAction.updateFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}

async function storeImageReq(file, id) {
  return paymentApi.storeImage(file, id);
}
function* get(action) {
  try {
    const response = yield call(getRequest, action.id);
    yield put(PaymentAction.getSuccess(response.data.data));
  } catch (error) {
    yield put(PaymentAction.getFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}
function getRequest(id) {
  return paymentApi.get(id);
}
